import { Node } from 'tiptap'

export default class File extends Node {

  get name() {
    return 'file'
  }

  get schema() {
    return {
      attrs: {
        src: {
          default: null,
        },
      },
      group: 'block',
      selectable: false,
      draggable: true,
      parseDOM: [{
        tag: `p[data-type="${this.name}"]`,
        priority: 59,
        getAttrs: dom => ({
          class: dom.getAttribute('class'),
          'data-type': dom.getAttribute('data-type'),
          src: dom.childNodes[0].getAttribute('href')
        }),
      }],
      toDOM: node => ['p', {
          class: 'editor__node-file',
          'data-type': this.name,
        }, ['a', {
            target: '_blank',
            href: node.attrs.src,
          }, 'Download Attachment'
        ]
      ]
    }
  }

  commands({ type }) {
    return attrs => (state, dispatch) => {
      const { selection } = state;
      const position = selection.$cursor
        ? selection.$cursor.pos
        : selection.$to.pos;
      const node = type.create(attrs);
      const transaction = state.tr.insert(position, node);
      dispatch(transaction);
    };
  }

}
